import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IntrackFeatureModule } from '../../intrack-feature.module';
import { ChipsWithSearchComponent } from './chips-with-search.component';
import { ChipsWithSearchComponentGeneric } from './chips-with-search-generic/chips-with-search-generic.component';
import { ChipsWithSearchGenericAndCheckboxes } from './chips-with-search-generic-and-checkboxes/chips-with-search-generic-and-checkboxes.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ChipsWithSearchComponent, ChipsWithSearchComponentGeneric, ChipsWithSearchGenericAndCheckboxes],
  imports: [CommonModule, IntrackFeatureModule, SvgIconModule],
  exports: [ChipsWithSearchComponent, ChipsWithSearchComponentGeneric, ChipsWithSearchGenericAndCheckboxes],
})
export class ChipsWithSearchModule {}
